import React, { FC, memo } from "react";
import { CheckoutFeedbackQuestionProjection } from "../../../../../projection/checkoutFeedback/checkoutFeedback";
import { checkoutFeedbackQuestionHasChildren } from "../../../../../projection/checkoutFeedback/checkoutFeedback.typeguards";
import { useCheckoutQuestionItem } from "./behaviors/useCheckoutQuestionItem";

interface CheckoutQuestionProps {
  readonly checkoutQuestionParentId: string;
  readonly checkoutQuestion: CheckoutFeedbackQuestionProjection;
}

const CheckoutQuestion: FC<CheckoutQuestionProps> = ({ checkoutQuestion, checkoutQuestionParentId }) => {
  const Item = useCheckoutQuestionItem({ type: checkoutQuestion.type });

  return (
    <Item
      checkoutQuestion={checkoutQuestion}
      checkoutQuestionParentId={checkoutQuestionParentId}
      testID={checkoutQuestion.id}
    >
      {checkoutFeedbackQuestionHasChildren(checkoutQuestion) &&
        checkoutQuestion.children.map((childCheckoutQuestion) => (
          <CheckoutQuestion
            key={childCheckoutQuestion.id}
            checkoutQuestion={childCheckoutQuestion}
            checkoutQuestionParentId={checkoutQuestion.id}
          />
        ))}
    </Item>
  );
};

export default memo(CheckoutQuestion);
